/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';
import TitleWithText from '@components/TitleWithText';
import { MIDDLE_STYLE } from '@constants/responsive';
import { useAppDispatch, useAuthState, useBusinessState } from '@core/configureStore';
import { fetchQuickBooksInfo } from '@core/features/business/thunks/fetchQuickBooksInfo.thunk';
import { heroApiService } from '@services/service-register';

type Props = {};

const ConnectQuickBooksIntegrationButton = (props: Props) => {
  const { user } = useAuthState();
  const dispatch = useAppDispatch();
  const { integration } = useBusinessState();
  const [loading, setLoading] = useState<boolean>(false);
  const [mount, setMount] = useState<boolean>(false);
  const handleConnect = async () => {
    if (!user) return;

    const rootUrl = `https://appcenter.intuit.com/connect/oauth2`;
    const options = {
      redirect_uri: process.env.REACT_APP_QUICKBOOKS_CALLBACK_URL as string,
      client_id: process.env.REACT_APP_QUICKBOOKS_APPLICATION_ID as string,
      response_type: 'code',
      scope: ['com.intuit.quickbooks.accounting'].join(' '),
      state: user.google_sub as unknown as string,
    };

    const qs = new URLSearchParams(options);
    window.open(`${rootUrl}?${qs.toString()}`);
  };

  const handleRefresh = async () => {
    if (!user) return;

    try {
      await dispatch(fetchQuickBooksInfo());
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogoutQuickBooks = async () => {
    if (!user) return;
    setLoading(true);
    try {
      await heroApiService.unintegrateQuickBooksFromLocation();
      await handleRefresh();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setMount(false);
      await handleRefresh();
      setMount(true);
      setLoading(false);
    };
    init();
  }, []);

  return mount && integration.quickbooks ? (
    <div
      style={{
        ...MIDDLE_STYLE,
        flexWrap: 'wrap',
        flexDirection: 'column',
      }}>
      <TitleWithText title="Connected Account">{integration.quickbooks}</TitleWithText>
      <br />
      <Button icon={<DisconnectOutlined />} onClick={handleLogoutQuickBooks}>
        Disconnect QuickBooks Integration
      </Button>
    </div>
  ) : (
    <Button loading={loading} onClick={handleConnect} style={{ ...MIDDLE_STYLE }}>
      <img
        alt="QuickBooks"
        src="quickbooks.png"
        width={25}
        height={25}
        style={{ marginRight: 10 }}
      />{' '}
      Connect to QuickBooks
    </Button>
  );
};

export default ConnectQuickBooksIntegrationButton;
